import React from 'react';
import {Carousel} from '../Carousel/Carousel';
import {Link} from '@homeaway/react-localization-components';
import classnames from 'classnames';
import {BathroomsElement} from '../BathroomsElement/BathroomsElement';
import BedroomsElement from '../BedroomsElement/BedroomsElement';
import SleepElement from '../SleepElement/SleepElement';
import {DualPriceElement} from '../DualPriceElement/DualPriceElement';
import RatingElement from '../RatingElement/RatingElement';
import Tooltip from '@homeaway/react-tooltip';
import {SVGIcon} from '@homeaway/react-svg';
import {INFO__16} from '@homeaway/svg-defs';
import './MapHit.less';

const hasBadges = (badges) => !!badges && !!badges.length;

const tooltipClickHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
};

const BadgeTooltip = ({helpText}) => {
    return (
        <div className={'HitInfo__badgeTooltip'} onClick={tooltipClickHandler}>
            <Tooltip
                centered
                shouldPersist
                hasCloseButton
                trigger="click"
                tooltipType="popover"
                content={helpText}
                placement="top"
                onClick={tooltipClickHandler}
            >
                <SVGIcon inline markup={INFO__16} />
            </Tooltip>
        </div>
    );
};

const superlative = (superlativesBadges, reviews) => {
    const hasReviews = reviews > 0;
    const {name, helpText} = superlativesBadges[0];
    const className = classnames('MapHit__superlative', {
        'MapHit__superlative--has-reviews': hasReviews,
    });

    return (
        <span>
            <span className={className}>{name}</span>
            {helpText && <BadgeTooltip helpText={helpText} />}
        </span>
    );
};

const MapHit = (props) => {
    const {infoWindowOptions} = props;
    const {bathrooms} = infoWindowOptions || {};
    const {
        half: bathroomsHalf,
        full: bathroomsFull,
        toiletOnly: bathroomsToiletOnly,
    } = bathrooms || {};
    const {propertyType} = infoWindowOptions || '';
    const {averageRating, reviewCount, sleeps, bedrooms} =
        infoWindowOptions || 0;
    const {superlativesBadges} = infoWindowOptions || [];
    const hasSuperlativeBadges = hasBadges(superlativesBadges);

    const onClick = () => {
        if (
            props.infoWindowOptions.onHitClick &&
            typeof props.infoWindowOptions.onHitClick === 'function'
        ) {
            props.infoWindowOptions.onHitClick({
                listingId: props.listingId,
                hitIndex: props.hitIndex,
            });
        }
    };
    return (
        <div className="MapHit" data-wdio="MapHit">
            <div
                className="MapHit__carousel content--clickable"
                data-wdio="MapHit__carousel"
            >
                <div className="Hit__tripboardButton">
                    {props.infoWindowOptions &&
                        props.infoWindowOptions.tripBoardButton &&
                        props.infoWindowOptions.tripBoardButton()}
                </div>
                <Link
                    href={
                        props.infoWindowOptions &&
                        props.infoWindowOptions.detailPageUrl
                    }
                >
                    {(localizedUrl) => (
                        <Carousel
                            {...props}
                            localizedUrl={localizedUrl}
                            onImageClick={onClick}
                        />
                    )}
                </Link>
            </div>
            <Link
                href={
                    props.infoWindowOptions &&
                    props.infoWindowOptions.detailPageUrl
                }
            >
                {(localizedUrl) => (
                    <a
                        className={'MapHit__link a--plain-link'}
                        href={localizedUrl}
                        target={'_blank'}
                    >
                        <div className="MapHit__info">
                            <div className="media-flex__row">
                                <div className="HitInfo__badgeRatingGroup">
                                    {reviewCount > 0 && (
                                        <div className="HitInfo__rating">
                                            <RatingElement
                                                averageRating={averageRating}
                                                reviewCount={reviewCount}
                                                isDualPrice
                                            />
                                        </div>
                                    )}
                                </div>
                                {hasSuperlativeBadges &&
                                    superlative(
                                        superlativesBadges,
                                        reviewCount
                                    )}
                            </div>
                            <div className="MapHit__info--details">
                                <BedroomsElement
                                    bedrooms={bedrooms}
                                    propertyType={propertyType}
                                />
                                <BathroomsElement
                                    bathroomsFull={bathroomsFull}
                                    bathroomsHalf={bathroomsHalf}
                                    bathroomsToiletOnly={bathroomsToiletOnly}
                                    bathrooms={bathrooms}
                                />
                                <SleepElement value={sleeps} shouldHideDot />
                            </div>
                            <div className="MapHit__info--priceRating">
                                <div className="MapHit__info--priceRating-price">
                                    <DualPriceElement
                                        infoWindowOptions={infoWindowOptions}
                                        isDesktop={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </a>
                )}
            </Link>
        </div>
    );
};

export {MapHit, BadgeTooltip};
